export default function replayVideo() {
    if(document.querySelector(".replay")) {
        let replay = document.querySelector(".replay");
        let video = document.querySelector(".video__content video");

        replay.addEventListener("click", () => {
            video.currentTime = 0;
        })
    }
}
